import React, { Dispatch, FC, SetStateAction } from 'react'
import { Box, IconButton, TextField } from '@mui/material'
import SearchSmallIcon from '../svg/SearchSmallIcon'
import ClearSvg from '../svg/ClearSvg'
import { SearchBarWrapper } from './styles/SelectSearchbar.styles'

interface Props {
  search: string
  placeholder: string
  setSearch: Dispatch<SetStateAction<string>>
}

const SelectSearchbar: FC<Props> = ({ search, placeholder, setSearch }) => {
  const inputHandler = (e: any) => {
    e.preventDefault()
    e.stopPropagation()

    setSearch(e.target.value)
  }

  return (
    <SearchBarWrapper>
      <Box className="search-icon">
        <SearchSmallIcon />
      </Box>
      <TextField
        className="search-bar"
        value={search}
        placeholder={placeholder || 'Search'}
        onInput={(e) => inputHandler(e)}
        onKeyDown={(e) => e.stopPropagation()}
        autoFocus={true}
        autoComplete="off"
      />
      {search ? (
        <IconButton className="clear-btn" onClick={() => setSearch('')}>
          <ClearSvg />
        </IconButton>
      ) : (
        ''
      )}
    </SearchBarWrapper>
  )
}

export default SelectSearchbar
